/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = UNKNOWN
 *
 * 1 = CAR
 *
 * 2 = VAN
 *
 * 3 = MOTORCYCLE
 *
 * 4 = TRUCK
 *
 * 5 = OTHER
 *
 * 6 = NOTAPPLICABLE
 *
 * 7 = BUS
 *
 * 8 = LIGHTTRUCK
 */
export enum VehicleClassType {
  UNKNOWN = 0,
  CAR = 1,
  VAN = 2,
  MOTORCYCLE = 3,
  TRUCK = 4,
  OTHER = 5,
  NOTAPPLICABLE = 6,
  BUS = 7,
  LIGHTTRUCK = 8,
}
